import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Seo, PageHeader } from "@/components/common";
import { Smile, Scissors, Eye, Sparkles, Scale, Bone } from "lucide-react";

export default function Treatments() {
  const { t } = useApp();
  const areas = [
    { icon: Smile, title: { tr: "Diş ve Gülüş Tasarımı", en: "Dental & Smile Design" }, active: true, to: "/tedaviler/dis" },
    { icon: Scissors, title: { tr: "Saç Ekimi", en: "Hair Transplant" }, active: false },
    { icon: Sparkles, title: { tr: "Estetik Cerrahi", en: "Aesthetic Surgery" }, active: false },
    { icon: Eye, title: { tr: "Göz Sağlığı", en: "Eye Health" }, active: false },
    { icon: Scale, title: { tr: "Obezite Cerrahisi", en: "Obesity Surgery" }, active: false },
    { icon: Bone, title: { tr: "Ortopedi", en: "Orthopaedics" }, active: false },
  ];

  return (
    <main data-testid="treatments-page">
      <Seo title={t({ tr: "Tedavi Alanları", en: "Treatment Areas" })} description={t({ tr: "Zeta Clinic tedavi alanları: diş ve gülüş tasarımı aktif; diğer alanlar yakında.", en: "Zeta Clinic treatment areas: dental and smile design active; other areas coming soon." })} />
      <PageHeader
        tag={{ tr: "Tedaviler", en: "Treatments" }}
        title={{ tr: "Tedavi alanlarımız", en: "Our treatment areas" }}
        subtitle={{ tr: "İlk fazda diş tedavileri ve gülüş tasarımına odaklanıyoruz. Diğer alanlar planlı olarak eklenecek.", en: "In the first phase we focus on dental treatments and smile design. Other areas will be added in a planned way." }}
      />
      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a, i) => {
            const Inner = (
              <>
                <div className={`w-11 h-11 rounded-[10px] flex items-center justify-center mb-5 ${a.active ? "bg-[var(--accent-soft)]" : "bg-white/5"}`}>
                  <a.icon size={20} className={a.active ? "text-[var(--accent)]" : "text-[#7C8B97]"} />
                </div>
                <h2 className={`font-heading font-semibold text-lg ${a.active ? "text-[#F2F5F7]" : "text-[#7C8B97]"}`}>{t(a.title)}</h2>
                {a.active ? (
                  <span className="inline-block mt-3 text-sm font-semibold text-[var(--accent)]">{t({ tr: "İncele →", en: "Explore →" })}</span>
                ) : (
                  <span className="inline-block mt-3 text-xs font-semibold uppercase tracking-wide rounded-full bg-white/10 text-[#7C8B97] px-3 py-1">{t({ tr: "Yakında", en: "Coming soon" })}</span>
                )}
              </>
            );
            return a.active ? (
              <Link key={i} to={a.to} data-testid="treatment-area-active" className="glass-card border-[var(--accent)]/30 p-8 hover:shadow-lg hover:-translate-y-1 transition-transform">
                {Inner}
              </Link>
            ) : (
              <div key={i} className="rounded-xl glass-card opacity-70 p-8">{Inner}</div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
